import { render, staticRenderFns } from "./UserContributionDataTable.vue?vue&type=template&id=279ec586&scoped=true&"
import script from "./UserContributionDataTable.vue?vue&type=script&lang=js&"
export * from "./UserContributionDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UserContributionDataTable.vue?vue&type=style&index=0&id=279ec586&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ec586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
